import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'vw-card-block-title',
    imports: [
        TranslatePipe
    ],
    templateUrl: './card-block-title.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './card-block-title.component.scss'
})
export class CardBlockTitleComponent {
  @Input() label: string;
}
